import { render, staticRenderFns } from "./VModelString.vue?vue&type=template&id=2548b9dd"
import script from "./VModelString.vue?vue&type=script&lang=js"
export * from "./VModelString.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports